import { Injectable } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { DataService } from './data.service';
import { EditVehiclePage } from 'src/app/modals/edit-vehicle/edit-vehicle.page';
import { AddVehiclePage } from 'src/app/modals/add-vehicle/add-vehicle.page';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { DisclaimersService } from './disclaimers.service';
import { LanguageService } from './language.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorHandlerService } from './error-handler.service';
import { LoaderService } from './loader.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class VehiclesService {
  provinces =[]
  plateTypes =[]
  makes =[]
  types =[]
  colours =[]
  loadingToggleChange = new BehaviorSubject<boolean>(false);
  vehicles:any = {};
  loaded = false;
  constructor(
    private toastSRV:ToastService,
    private loaderSRV:LoaderService,
    private disclaimerSRV:DisclaimersService,
    private alertController: AlertController,
    private router: Router,
    public modalController: ModalController,
    private dataService: DataService,
    public translateService: TranslateService,
    private errorHandlerSRV:ErrorHandlerService
  ) {}
  async removeVehicle(vehicle){
    const removeVehicleAlert = await this.alertController.create({
      header:this.translateService.instant('keys.data.vehicles.remove_confirm') || 'Confirm Remove Vehicle',
      message: this.translateService.instant('keys.data.vehicles.remove_confirm_message') || 'Are you sure you want to remove this vehicle from your profile?',
      buttons: [
        {
          text: this.translateService.instant('keys.data.common.close') || 'Close',
          handler: () => {},
        },
        {
          text: this.translateService.instant('keys.data.common.remove') || 'Remove',
          handler: () => {
            this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.loading') || 'Loading...')
            this.dataService.postData('vehicles/remove/' + vehicle?.VehicleID + '/endpoint',{}).subscribe({
              next:(res:any)=>{
                this.loaderSRV.dismissLoader()
                if(res.status=='success'){
                  this.toastSRV.presentToast(res?.message)
                  this.refreshVehicles()
                } else {
                  this.errorHandlerSRV.displayErrorMessage(res,true)
                }
              },error:err=>{
                this.errorHandlerSRV.displayErrorMessage(err,true)
              }
            })
            
          }
        }
      ],
    });
    const cannotRemoveVehicleAlert = await this.alertController.create({
      message: this.translateService.instant('keys.data.vehicles.cannot_remove') || 'This vehicle cannot be removed from your profile.',
      buttons: [
        {
          text: this.translateService.instant('keys.data.common.close') || 'Close',
          handler: () => {},
        },
      ],
    });
    if(vehicle?.allow_remove){
      await removeVehicleAlert.present();
    } else {
      await cannotRemoveVehicleAlert.present();
    }
    
  }
  refreshVehicles(){
    this.getVehicles().subscribe({
      next:(response:any)=>{
        this.loaded=true
        if(response?.status=='success'){
          this.vehicles = response?.vehicles;
          this.provinces=this.dataService.sortProvincesByCountry(response?.provinces)
          this.colours=response?.colours
          this.makes=response?.makes
          this.plateTypes=response?.plateTypes
          this.types=response?.types
          
        } else {
          this.errorHandlerSRV.displayErrorMessage(response,true)
        }
      },error:err=>{
        this.errorHandlerSRV.displayErrorMessage(err,true)
      }
    })
  }
   getVehicles() {
    this.loaded=false
    this.vehicles = {};
    return this.dataService.getData('api/v1/user/vehicles')
  }
  async addVehicleModal(vehicles){
    const modal = await this.modalController.create({
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      component: AddVehiclePage,
      cssClass:"modal-mobile-normal",
      componentProps: {
        vehicles: vehicles,
      },
    });
    // Reload data on Modal Dismiss
    modal.onDidDismiss().then((res) => {
    
        if (res.data?.reload) {

          this.refreshVehicles();
          this.router.navigateByUrl('/vehicles')
        }
      
    });
    return await modal.present();
  }
  async proceed(){
    
    if(JSON.stringify(this.vehicles) === '{}' || this.provinces.length<1 || this.colours.length<1 || this.makes.length<1 || this.plateTypes.length<1 || this.types.length<1)
    {
      this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.loading') || 'Loading...')
      this.getVehicles().subscribe({
        next:(response:any)=>{
          this.loaderSRV.dismissLoader()
          if(response?.status=='success'){
            this.vehicles = response?.vehicles;
            this.provinces=this.dataService.sortProvincesByCountry(response?.provinces)
            this.colours=response?.colours
            this.makes=response?.makes
            this.plateTypes=response?.plateTypes
            this.types=response?.types
            this.loaded=true
            this.addVehicleModal(this.vehicles)
          } else {
            this.errorHandlerSRV.displayErrorMessage(response,true)
          }
        },error:err=>{
          this.loaderSRV.dismissLoader()
          this.errorHandlerSRV.displayErrorMessage(err,true)
        }
      })
      
    } else {
      this.addVehicleModal(this.vehicles)
    }
    
  }
  async openAddVehicleModal() {
    var disclaimer;
    disclaimer= this.disclaimerSRV.disclaimers.find(disclaimer=>disclaimer['data_trigger']=='add-vehicle-button' && disclaimer['locale']==this.dataService.selected)

    if(disclaimer && disclaimer['active']){
      this.dataService.createAndOpenModal(disclaimer).then(data=>{
        if(data){
         this.proceed()
        }
         
       })
    } else {
      this.proceed()
    }
    
  }
  async openEditVehicleModal(vehicle) {
   
    const modal = await this.modalController.create({
      component: EditVehiclePage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass:"modal-mobile-normal",
      componentProps: {
        vehicles: this.vehicles,
        vehicle,
      },
    });

    // Reload data on Modal Dismiss
    modal.onDidDismiss().then((res) => {
     
      const { data } = res;
      if (data) {
        if (data.reload) {
          this.refreshVehicles();
        }
      }
    });
    return await modal.present();
  }
  onToggleActiveFromHomepage(vehicle){
    var status
    this.loadingToggleChange.next(true);
    if(vehicle.Active == false || !vehicle.Active){
       status = "active"
    } else {
       status = "inactive"
    }
   
   this.switchStateEndpoint(vehicle.VehicleID,status)
  }
  onToggleActive(e, vehicleId) {
    this.loadingToggleChange.next(true);
    const status = e.target.checked == true ? 'active' : 'inactive';
    
    this.switchStateEndpoint(vehicleId,status,e)
    // Get vehicles data once the status is changed
    
  }
  switchStateEndpoint(vehicleId,status,e?){
    const url = `api/v1/user/vehicles/toggleactive/${vehicleId}/${status}`;
    this.dataService.getData(url).subscribe({
      next: (res:any) => {
        if(res['status']=="success"){
          this.vehicles.forEach((element) => {
            if (element['VehicleID'] == vehicleId) {
              if(status=="active"){
                element.Active = true
              } else {
                element.Active = false
              }
              
            } 
            if(res?.oldVehicleID){
              if (element['VehicleID'] == res?.oldVehicleID) {
                element.Active = false
              }
        }
          });
          this.loadingToggleChange.next(false);
        } else {
          if(res?.message){
            this.errorAlert(res.message);

          } else if(res?.errors?.Year){
            this.errorAlert(res.errors.Year);
          }
          this.loadingToggleChange.next(false);
        }
        
      },
      error: (err) => {
        if(err.message){
          this.errorAlert(err.message);

        } else if(err.errors.Year){
          this.errorAlert(err.errors.Year);
        }
        
        this.loadingToggleChange.next(false);
      },
    });
  }
  async errorAlert(message) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      message: message,
      buttons: [
        {
          text: this.translateService.instant('keys.data.common.close') || 'Close',
          handler: () => {},
        },
      ],
    });

    await alert.present();
  }
}
